import { render, staticRenderFns } from "./Cost.vue?vue&type=template&id=1652c64c&"
import script from "./Cost.vue?vue&type=script&lang=js&"
export * from "./Cost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports